import { cn } from '@core/utils';

interface NarrowContentContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * 로그인, 회원가입 content 정렬을 위한 컴포넌트
 */
export const NarrowContentContainer = ({
  children,
  className,
}: NarrowContentContainerProps) => {
  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-screen-sm flex-1 flex-col',
        className,
      )}
    >
      {children}
    </div>
  );
};
